import React, { useState } from 'react';

import { Combobox } from '@eika/combobox';

import useTranslation from '../../../../hooks/useTranslation';
import { CrossBorderPaymentActionType } from '../form/actions';
import useFormContext from '../form/useFormContext';
import { AmountFieldsError } from '../form/validate';

interface Props {
    error?: string;
    setError: (errors: AmountFieldsError) => void;
}

const TransferCurrencySelect: React.FC<Props> = ({ error, setError }) => {
    const translated = useTranslation();
    const { state, handleChange } = useFormContext();
    const [chosenCurrency, setChosenCurrency] = useState('');

    return (
        <div className="currency-select__search-select">
            {state.country?.transferCurrencies && (
                <Combobox
                    id="transfer-currency"
                    label={translated.currencyField.title}
                    suggestions={state.country.transferCurrencies.map((currency) => {
                        return {
                            value: `${currency.currency} - ${currency.name}`,
                        };
                    })}
                    value={chosenCurrency}
                    onChange={(value) => setChosenCurrency(value)}
                    onSelect={(value) => {
                        const [currency] = value.toString().split(' -');

                        handleChange({
                            type: CrossBorderPaymentActionType.TRANSFER_CURRENCY,
                            payload: currency,
                        });
                        setChosenCurrency(value.toString());
                        setError({ transferCurrency: undefined });
                    }}
                    searchInput
                    hideSearchIcon
                    error={error}
                />
            )}
        </div>
    );
};

export default TransferCurrencySelect;
